"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardProvider = exports.CardContext = void 0;
var react_1 = require("react");
exports.CardContext = react_1.createContext({ size: 'lg' });
exports.CardProvider = exports.CardContext.Provider;
